import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/i18n";

const seo = {
  it: {
    title: "Studio Noom | Brand Designer & Visual Identity a Modena",
    description:
      "Brand design e identità visiva strategica a Modena per studi professionali e brand lifestyle. Trasforma la tua immagine in un asset di valore riconoscibile.",
  },
  en: {
    title: "Studio Noom | Brand Designer & Visual Identity in Modena",
    description:
      "Strategic brand design and visual identity in Modena for professional firms and lifestyle brands. Turn your image into a recognisable, valuable asset.",
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("noom-lang") || "it");

  useEffect(() => {
    localStorage.setItem("noom-lang", lang);
    document.documentElement.lang = lang;
    document.title = seo[lang].title;
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", seo[lang].description);
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
